/* global gemius_hit */
import { GEMIUS_IDENTIFIER } from 'website/configuration/constants';

export function gemiusHit() {
  // eslint-disable-next-line camelcase
  if (typeof gemius_hit === 'function') {
    gemius_hit(GEMIUS_IDENTIFIER);
  }
}
